import { NgModule } from '@angular/core';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { HttpClientModule, HttpClientJsonpModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { TitleStrategy } from '@angular/router';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgbModule, NgbTooltipModule, NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { environment } from '../environments/environment';
import { ToastsComponent } from './components/toasts/toasts.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { SessionLayoutComponent } from './layouts/session-layout/session-layout.component';
import { LogInPageComponent } from './pages/log-in-page/log-in-page.component';
import { DashboardLayoutComponent } from './layouts/dashboard-layout/dashboard-layout.component';
import { SideBarComponent } from './components/side-bar/side-bar.component';
import { MenuItemComponent } from './components/menu-item/menu-item.component';
import { MainHeaderComponent } from './components/main-header/main-header.component';
import { NotificationsBellComponent } from './components/notifications-bell/notifications-bell.component';
import { DashboardPageComponent } from './pages/dashboard/dashboard-page/dashboard-page.component';
import { NeighborhoodsPageComponent } from './pages/dashboard/neighborhoods-page/neighborhoods-page.component';
import { SideMenuComponent } from './components/side-menu/side-menu.component';
import { NeighborhoodTypesPageComponent } from './pages/dashboard/neighborhood-types-page/neighborhood-types-page.component';
import { ProofTypesPageComponent } from './pages/dashboard/proof-types-page/proof-types-page.component';
import { VisitTypesPageComponent } from './pages/dashboard/visit-types-page/visit-types-page.component';
import { ModulesPageComponent } from './pages/dashboard/security/modules-page/modules-page.component';
import { ProfilesPageComponent } from './pages/dashboard/security/profiles-page/profiles-page.component';
import { UsersPageComponent } from './pages/dashboard/security/users-page/users-page.component';
import { UserPageComponent } from './pages/dashboard/security/user-page/user-page.component';
import { ModuleModalComponent } from './components/module-modal/module-modal.component';
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// import { BaseChartDirective } from 'ng2-charts';

// ANCHOR NGPRIME
import { TableModule } from 'primeng/table';
import { InputSwitchModule } from 'primeng/inputswitch';
import { ProgressBarModule } from 'primeng/progressbar';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { CarouselModule } from 'primeng/carousel';
import { ChartModule } from 'primeng/chart';
import { InputNumberModule } from 'primeng/inputnumber';
import { CalendarModule } from 'primeng/calendar';
import { MenuModule } from 'primeng/menu';
import { SkeletonModule } from 'primeng/skeleton';


import { NeighborhoodTypeModalComponent } from './components/neighborhood-type-modal/neighborhood-type-modal.component';
import { ProofTypeModalComponent } from './components/proof-type-modal/proof-type-modal.component';
import { VisitTypeModalComponent } from './components/visit-type-modal/visit-type-modal.component';
import { NeighborhoodModalComponent } from './components/neighborhood-modal/neighborhood-modal.component';
import { NeighborhoodLayoutComponent } from './layouts/neighborhood-layout/neighborhood-layout.component';
import { NeighborhoodPageComponent } from './pages/neighborhood/neighborhood-page/neighborhood-page.component';
import { VisitsPageComponent } from './pages/neighborhood/visits-page/visits-page.component';
import { StreetsBuildingPageComponent } from './pages/neighborhood/streets-building-page/streets-building-page.component';
import { HousesFlatsPageComponent } from './pages/neighborhood/houses-flats-page/houses-flats-page.component';
import { SettlersPageComponent } from './pages/neighborhood/settlers-page/settlers-page.component';
import { SettingsModulesPageComponent } from './pages/neighborhood/settings/settings-modules-page/settings-modules-page.component';
import { SettingsProfilesPageComponent } from './pages/neighborhood/settings/settings-profiles-page/settings-profiles-page.component';
import { GeneralPageComponent } from './pages/neighborhood/settings/general-page/general-page.component';
import { AddressPageComponent } from './pages/neighborhood/settings/address-page/address-page.component';
import { StreetBuildingModalComponent } from './components/street-building-modal/street-building-modal.component';
import { StreetBuildingItemComponent } from './components/street-building-item/street-building-item.component';
import { HouseFlatModalComponent } from './components/house-flat-modal/house-flat-modal.component';
import { StreetBuildingItem2Component } from './components/street-building-item-2/street-building-item-2.component';
import { ResidentsModalComponent } from './components/residents-modal/residents-modal.component';
import { NotificationTypesPageComponent } from './pages/dashboard/catalogues/notification-types-page/notification-types-page.component';
import { NotificationTypeModalComponent } from './components/notification-type-modal/notification-type-modal.component';
import { ServicesPageComponent } from './pages/neighborhood/settings/services-page/services-page.component';
import { ServiceModalComponent } from './components/service-modal/service-modal.component';
import { AnnouncementsPageComponent } from './pages/neighborhood/announcements-page/announcements-page.component';
import { CreateAnnouncementModalComponent } from './components/create-announcement-modal/create-announcement-modal.component';
import { AnnouncementModalComponent } from './components/announcement-modal/announcement-modal.component';
import { NoticeViolationsPageComponent } from './pages/neighborhood/notice-violations-page/notice-violations-page.component';
import { HouseFlatNoticeViolationsPageComponent } from './pages/neighborhood/house-flat-notice-violations-page/house-flat-notice-violations-page.component';
import { CreateNoticeViolationModalComponent } from './components/create-notice-violation-modal/create-notice-violation-modal.component';
import { NoticeViolationModalComponent } from './components/notice-violation-modal/notice-violation-modal.component';
import { GuardsPageComponent } from './pages/dashboard/guards-page/guards-page.component';
import { VisitListComponent } from './components/visit-list/visit-list.component';
import { VisitModalComponent } from './components/visit-modal/visit-modal.component';
import { NewlineToBrPipe } from './pipes/newline-to-br.pipe';
import { EmergencyNumbersPageComponent } from './pages/neighborhood/emergency-numbers-page/emergency-numbers-page.component';
import { EmergencyNumberModalComponent } from './components/emergency-number-modal/emergency-number-modal.component';
import { NeighborhoodItemComponent } from './components/neighborhood-item/neighborhood-item.component';
import { PaymentsPageComponent } from './pages/neighborhood/payments-page/payments-page.component';
import { PaymentPageComponent } from './pages/neighborhood/payment-page/payment-page.component';
import { PaymentPageSkeletonComponent } from './pages/neighborhood/payment-page/loaders/payment-page-skeleton.component';
import { BankAccountTypeModalComponent } from './components/bank-account-type-modal/bank-account-type-modal.component';
import { BankAccountTypesPageComponent } from './pages/dashboard/bank-account-types-page/bank-account-types-page.component';
import { BankAccountItemComponent } from './components/bank-account-item/bank-account-item.component';
import { BankAccountsPageComponent } from './pages/dashboard/bank-accounts-page/bank-accounts-page.component';
import { BankAccountModalComponent } from './components/bank-account-modal/bank-account-modal.component';
import { StreetBuildingPaymentItemComponent } from './components/street-building-payment-item/street-building-payment-item.component';
import { ChargeItemComponent } from './components/charge-item/charge-item.component';
import { DateToMomentPipe } from './pipes/date-to-moment.pipe';
import { PaymentModalComponent } from './components/payment-modal/payment-modal.component';
import { PlatformPageComponent } from './pages/dashboard/platform-page/platform-page.component';
import { PlatformsPageComponent } from './pages/dashboard/platforms-page/platforms-page.component';
import { PlatformModalComponent } from './components/platform-modal/platform-modal.component';
import { FaqGroupModalComponent } from './components/faq-group-modal/faq-group-modal.component';
import { FaqModalComponent } from './components/faq-modal/faq-modal.component';
import { ParcelServicesPageComponent } from './pages/dashboard/parcel-services-page/parcel-services-page.component';
import { ParcelServiceModalComponent } from './components/parcel-service-modal/parcel-service-modal.component';
import { GalleriaModule } from 'primeng/galleria';
import { ImageModule } from 'primeng/image';
import { MovementsPageComponent } from './pages/dashboard/movements-page/movements-page.component';
import { MovementModalComponent } from './components/movement-modal/movement-modal.component';
import { GatesPageComponent } from './pages/neighborhood/gates-page/gates-page.component';
import { GateModalComponent } from './components/gate-modal/gate-modal.component';
import { AccessDoorGroupTypeModalComponent } from './components/access-door-group-type-modal/access-door-group-type-modal.component';
import { AccessDoorGroupTypesPageComponent } from './pages/neighborhood/access-door-group-types-page/access-door-group-types-page.component';
import { TagTypeModalComponent } from './components/tag-type-modal/tag-type-modal.component';
import { TagTypesPageComponent } from './pages/dashboard/tag-types-page/tag-types-page.component';
import { DevicesModalComponent } from './components/devices-modal/devices-modal.component';
import { GatePageComponent } from './pages/dashboard/gate-page/gate-page.component';
import { AccessDoorGroupModalComponent } from './components/access-door-group-modal/access-door-group-modal.component';
import { AccessDoorModalComponent } from './components/access-door-modal/access-door-modal.component';
import { RulesPageComponent } from './pages/neighborhood/settings/rules-page/rules-page.component';
import { AdministratorModalComponent } from './components/administrator-modal/administrator-modal.component';
import { AmenityModalComponent } from './components/amenity-modal/amenity-modal.component';
import { AmenitiesPageComponent } from './pages/neighborhood/amenities-page/amenities-page.component';
import { TimetableModalComponent } from './components/timetable-modal/timetable-modal.component';
import { TimetableItemComponent } from './components/timetable-item/timetable-item.component';
import { CreateBookingModalComponent } from './components/create-booking-modal/create-booking-modal.component';
import { BookingsPageComponent } from './pages/neighborhood/bookings-page/bookings-page.component';
import { BookingsCalendarComponent } from './components/bookings-calendar/bookings-calendar.component';
import { BookingDetailModalComponent } from './components/booking-detail-modal/booking-detail-modal.component';
import { SelectAmenityModalComponent } from './components/select-amenity-modal/select-amenity-modal.component';
import { SurveyModalComponent } from './components/survey-modal/survey-modal.component';
import { SurveysPageComponent } from './pages/neighborhood/surveys-page/surveys-page.component';
import { SurveyPageComponent } from './pages/neighborhood/survey-page/survey-page.component';
import { QuestionModalComponent } from './components/question-modal/question-modal.component';
import { AnswerItemModalComponent } from './components/answer-item-modal/answer-item-modal.component';
import { TagModalComponent } from './components/tag-modal/tag-modal.component';
import { TagsModalComponent } from './components/tags-modal/tags-modal.component';
import { SosLogsPageComponent } from './pages/neighborhood/sos-logs-page/sos-logs-page.component';
import {  NgxEchartsModule  }  from  'ngx-echarts';
import { AdministratorsPageComponent } from './pages/dashboard/administrators-page/administrators-page.component';
import { GuardModalComponent } from './components/guard-modal/guard-modal.component';
import { UserViewModalComponent } from './components/user-view-modal/user-view-modal.component';
import { CamerasPageComponent } from './pages/neighborhood/cameras-page/cameras-page.component';
import { CameraModalComponent } from './components/camera-modal/camera-modal.component';
import { HouseFlatPageComponent } from './pages/dashboard/neighborhood/house-flat-page/house-flat-page.component';
import { HouseFlatVisitsPageComponent } from './pages/dashboard/neighborhood/house-flat-visits-page/house-flat-visits-page.component';
import { HouseFlatPasesPageComponent } from './pages/neighborhood/house-flat-pases-page/house-flat-pases-page.component';
import { PassesPageComponent } from './pages/neighborhood/passes-page/passes-page.component';
import { NeighborhoodPassesPageComponent } from './pages/neighborhood/neighborhood-passes-page/neighborhood-passes-page.component';
import { HouseFlatCodeComponent } from './components/house-flat-code/house-flat-code.component';
import { ReportsPageComponent } from './pages/neighborhood/reports-page/reports-page.component';
import { ReportModalComponent } from './components/report-modal/report-modal.component';
import { ReportListComponent } from './pages/neighborhood/report-list/report-list.component';
import { CreateReportModalComponent } from './components/create-report-modal/create-report-modal.component';
import { ReportCancelModalComponent } from './components/report-cancel-modal/report-cancel-modal.component';
import { PackageModalComponent } from './components/package-modal/package-modal.component';
import { PackagesPageComponent } from './pages/neighborhood/packages-page/packages-page.component';
import { PackagesListComponent } from './pages/neighborhood/packages-list/packages-list.component' ;
import { SettingsPassesPageComponent } from './pages/neighborhood/settings/settings-passes-page/settings-passes-page.component';
import { SettingsPaymentsPageComponent } from './pages/neighborhood/settings/settings-payments-page/settings-payments-page.component';
import { AccessDoorTypesPageComponent } from './pages/dashboard/access-door-types-page/access-door-types-page.component';
import { AccessDoorTypeModalComponent } from './components/access-door-type-modal/access-door-type-modal.component';
import { ChargeCycleModalComponent } from './components/charge-cycle-modal/charge-cycle-modal.component';
import { ChargeCyclesPageComponent } from './pages/neighborhood/settings/charge-cycles-page/charge-cycles-page.component';
import { HouseCreditModalComponent } from './components/house-credit-modal/house-credit-modal.component';
import { HouseFlatPaymentsPageComponent } from './pages/neighborhood/house-flat-payments-page/house-flat-payments-page.component';
import { MovementsCreditsPageComponent } from './pages/neighborhood/movements-credits-page/movements-credits-page.component';
import { HouseFlatPaymentHistoryPageComponent } from './pages/neighborhood/house-flat-payment-history-page/house-flat-payment-history-page.component';
import { HouseFlatCreditHistoryPageComponent } from './pages/neighborhood/house-flat-credit-history-page/house-flat-credit-history-page.component';
import { PaymentMethodModalComponent } from './components/payment-method-modal/payment-method-modal.component';
import { PaymentMethodsPageComponent } from './pages/dashboard/catalogues/payment-methods-page/payment-methods-page.component';
import { ExternalServiceLogsPageComponent } from './pages/shared/external-service-logs-page/external-service-logs-page.component';
import { ExternalServiceLogPageComponent } from './pages/shared/external-service-log-page/external-service-log-page.component';
import { HouseFlatNotificationModalComponent } from './components/house-flat-notification-modal/house-flat-notification-modal.component';
import { AppTitleStrategy } from './services/title-strategy.service';
import { RelativeDayPipe } from './pipes/relative-day.pipe';
import { McpSessionsPageComponent } from './pages/dashboard/mcp-sessions-page/mcp-sessions-page.component';


@NgModule({
  declarations: [
    AppComponent,
    ToastsComponent,
    SpinnerComponent,
    SessionLayoutComponent,
    LogInPageComponent,
    DashboardLayoutComponent,
    SideBarComponent,
    MenuItemComponent,
    MainHeaderComponent,
    NotificationsBellComponent,
    DashboardPageComponent,
    NeighborhoodsPageComponent,
    SideMenuComponent,
    NeighborhoodTypesPageComponent,
    ProofTypesPageComponent,
    VisitTypesPageComponent,
    ModulesPageComponent,
    ProfilesPageComponent,
    UsersPageComponent,
    UserPageComponent,
    ModuleModalComponent,
    NeighborhoodTypeModalComponent,
    ProofTypeModalComponent,
    VisitTypeModalComponent,
    NeighborhoodModalComponent,
    NeighborhoodLayoutComponent,
    NeighborhoodPageComponent,
    VisitsPageComponent,
    StreetsBuildingPageComponent,
    HousesFlatsPageComponent,
    SettlersPageComponent,
    SettingsModulesPageComponent,
    SettingsProfilesPageComponent,
    GeneralPageComponent,
    AddressPageComponent,
    StreetBuildingModalComponent,
    StreetBuildingItemComponent,
    HouseFlatModalComponent,
    StreetBuildingItem2Component,
    ResidentsModalComponent,
    NotificationTypesPageComponent,
    NotificationTypeModalComponent,
    ServicesPageComponent,
    ServiceModalComponent,
    AnnouncementsPageComponent,
    CreateAnnouncementModalComponent,
    AnnouncementModalComponent,
    NoticeViolationsPageComponent,
    HouseFlatNoticeViolationsPageComponent,
    CreateNoticeViolationModalComponent,
    NoticeViolationModalComponent,
    GuardsPageComponent,
    VisitListComponent,
    VisitModalComponent,
    NewlineToBrPipe,
    EmergencyNumbersPageComponent,
    EmergencyNumberModalComponent,
    NeighborhoodItemComponent,
    PaymentsPageComponent,
    PaymentPageComponent,
    PaymentPageSkeletonComponent,
    BankAccountTypeModalComponent,
    BankAccountTypesPageComponent,
    BankAccountItemComponent,
    BankAccountsPageComponent,
    BankAccountModalComponent,
    StreetBuildingPaymentItemComponent,
    ChargeItemComponent,
    DateToMomentPipe,
    PaymentModalComponent,
    PlatformPageComponent,
    PlatformsPageComponent,
    PlatformModalComponent,
    FaqGroupModalComponent,
    FaqModalComponent,
    ParcelServicesPageComponent,
    ParcelServiceModalComponent,
    MovementsPageComponent,
    MovementModalComponent,
    GatesPageComponent,
    GateModalComponent,
    AccessDoorGroupTypeModalComponent,
    AccessDoorGroupTypesPageComponent,
    TagTypeModalComponent,
    TagTypesPageComponent,
    DevicesModalComponent,
    GatePageComponent,
    AccessDoorGroupModalComponent,
    AccessDoorModalComponent,
    RulesPageComponent,
    AdministratorModalComponent,
    AmenityModalComponent,
    AmenitiesPageComponent,
    TimetableModalComponent,
    TimetableItemComponent,
    CreateBookingModalComponent,
    BookingsPageComponent,
    BookingsCalendarComponent,
    BookingDetailModalComponent,
    SelectAmenityModalComponent,
    SurveyModalComponent,
    SurveysPageComponent,
    SurveyPageComponent,
    QuestionModalComponent,
    AnswerItemModalComponent,
    TagModalComponent,
    TagsModalComponent,
    SosLogsPageComponent,
    AdministratorsPageComponent,
    GuardModalComponent,
    UserViewModalComponent,
    CamerasPageComponent,
    CameraModalComponent,
    HouseFlatPageComponent,
    HouseFlatVisitsPageComponent,
    HouseFlatPasesPageComponent,
    PassesPageComponent,
    NeighborhoodPassesPageComponent,
    HouseFlatCodeComponent,
    ReportsPageComponent,
    ReportModalComponent,
    ReportListComponent,
    CreateReportModalComponent,
    ReportCancelModalComponent,
    PackageModalComponent,
    PackagesPageComponent,
    PackagesListComponent,
    SettingsPassesPageComponent,
    SettingsPaymentsPageComponent,
    AccessDoorTypesPageComponent,
    AccessDoorTypeModalComponent,
    ChargeCycleModalComponent,
    ChargeCyclesPageComponent,
    HouseCreditModalComponent,
    HouseFlatPaymentsPageComponent,
    MovementsCreditsPageComponent,
    HouseFlatPaymentHistoryPageComponent,
    HouseFlatCreditHistoryPageComponent,
    PaymentMethodModalComponent,
    PaymentMethodsPageComponent,
    ExternalServiceLogsPageComponent,
    ExternalServiceLogPageComponent,
    HouseFlatNotificationModalComponent,
    RelativeDayPipe,
    McpSessionsPageComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    HttpClientModule,
    HttpClientJsonpModule,
    TableModule,
    InputSwitchModule,
    ProgressBarModule,
    ButtonModule,
    DropdownModule,
    NgbCollapseModule,
    NgbTooltipModule,
    GalleriaModule,
    ImageModule,
    CarouselModule,
    NgbDatepickerModule,
    ChartModule,
    InputNumberModule,
    CalendarModule,
    MenuModule,
    SkeletonModule,
    DragDropModule,
    NgxEchartsModule.forRoot({
      /**
       * This will import all modules from echarts.
       * If you only need custom modules,
       * please refer to [Custom Build] section.
       */
      echarts: () => import('echarts'), // or import('./path-to-my-custom-echarts')
    }),
  ],
  providers: [
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAuth(() => getAuth()),
    { provide: TitleStrategy, useClass: AppTitleStrategy }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
